import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import IBetConfig from '../../vendor_core/core/src/managers/contracts/configurations/IBetConfig';
import BetModel from '../../vendor_core/core/src/model/BetModel';

class BetConfig implements IBetConfig {
    public type: ConfigurationTypes = ConfigurationTypes.BET;
    public betOptions = [20, 40, 60, 100, 200, 300, 500, 1000, 2000, 3000, 4000, 5000];
    public getBetOptions(): number[] {
        let result = [];
        if (this.betOptions.length > 0) {
            if (BetModel.creditValues.length <= this.betOptions.length) {
                result = BetModel.creditValues;
            } else {
                let validBets = [...BetModel.creditValues];
                // push first valid bet
                result.push(validBets.shift());
                // push last valid bet
                result.push(validBets.pop());
                validBets.forEach(bet => {
                    if (this.betOptions.includes(bet)) {
                        result.push(bet)
                    }
                })
            }
            // this.betOptions.forEach(bet => {
            //     if (BetModel.creditValues.includes(bet)) {
            //         result.push(bet)
            //     }
            // })
        } else {
            result = BetModel.creditValues;
        }



        return result.sort((a, b) => a - b)
    };
}

export default new BetConfig()
